module.exports = require('./helpers/bundle-url').getBundleURL('01RMl') + "lanhao-min.fc9425e7.jpg";